import { MainMenuItem } from '..';
import { findActiveUrl, subItemContainsActive } from '../navActive';

/**
 * Only one section, and within it only one group, is ever open at a time —
 * there's no independent per-node state. Finds which section/group (if any)
 * contains the active route, so the sidebar always opens on wherever you are.
 * Resolves `pathname` to its active url once (see `findActiveUrl` — this is
 * what lets a detail route reached via a search result or an in-page link,
 * rather than the nav itself, still open its owning section) and reuses that
 * resolution for every sub-item, rather than re-deriving it per node. A
 * `null` groupId means either no group is active, or the matching sub-item
 * is a flat link rather than an expandable group.
 */
export const findOpenPath = (
  menuData: MainMenuItem[],
  pathname: string
): { sectionId: string | null; groupId: string | null } => {
  const activeUrl = findActiveUrl(menuData, pathname);
  for (const item of menuData) {
    if (!item.subMenuItems?.length) continue;
    for (const sub of item.subMenuItems) {
      if (subItemContainsActive(activeUrl, sub)) {
        return { sectionId: item.id, groupId: sub.subMenuItems?.length ? sub.id : null };
      }
    }
  }
  return { sectionId: null, groupId: null };
};

/** Ids of every collapsible node (sections and their groups), in render order. */
export const expandableIds = (menuData: MainMenuItem[]): string[] => {
  const ids: string[] = [];
  for (const item of menuData) {
    if (!item.subMenuItems?.length) continue;
    ids.push(item.id);
    for (const sub of item.subMenuItems) {
      if (sub.subMenuItems?.length) ids.push(sub.id);
    }
  }
  return ids;
};
